import { ToggleButtonGroup, ToggleButton, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';

const AnsichtToggle = ({ ansicht, onChange }) => (
    <ToggleButtonGroup
        value={ansicht}
        exclusive
        onChange={onChange}
        size="small"
        sx={{
            mb: 2,
            backgroundColor: 'background.paper',
            borderRadius: '16px',
            '& .MuiToggleButton-root': {
                color: 'primary.main',
                '&.Mui-selected': {
                    backgroundColor: 'primary.dark',
                    color: '#fff',
                },
            },
        }}
    >
        <ToggleButton value="gruppe">
            <GroupIcon sx={{ mr: 0.5 }} fontSize="small" />
            <Typography variant="caption">Gruppe</Typography>
        </ToggleButton>
        <ToggleButton value="persoenlich">
            <PersonIcon sx={{ mr: 0.5 }} fontSize="small" />
            <Typography variant="caption">Persönlich</Typography>
        </ToggleButton>
    </ToggleButtonGroup>
);

export default AnsichtToggle;
